import { Text } from 'components/Typography'
import React, { useEffect, useState } from 'react'
import { Flex } from 'reflexbox/styled-components'
import { Container } from './style'

const calculateTimeLeft = () => {
  let finnally = new Date('01/15/2022 8:0:0')
  let moment = new Date()
  const difference = +finnally - +moment
  let timeLeft = {}

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    }
  }

  return timeLeft
}

const CountDowntimer = () => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearTimeout(timer)
  })

  const DisplayDays = ({ days }) => {
    if (!days) return <></>
    return <Text ml={1} mr={1}>{`${days} ${days == 1 ? 'dia' : 'dias'},`}</Text>
  }

  const DisplayHours = ({ hours }) => {
    if (!hours) return <></>
    return <Text ml={1} mr={1}>{`${hours} ${hours == 1 ? 'hora' : 'horas'},`}</Text>
  }

  const DisplayMinutes = ({ minutes }) => {
    if (!minutes) return <></>
    return <Text ml={1} mr={1}>{`${minutes} ${minutes == 1 ? 'min' : 'mins'} e`}</Text>
  }

  const DisplaySeconds = ({ seconds }) => {
    if (!seconds) return <></>
    return <Text ml={1} mr={1}>{`${seconds} ${seconds == 1 ? 'sec' : 'segs'}`}</Text>
  }

  return (
    <>
      <Container>
        <Flex flexDirection={['column', 'row']} justifyContent='flex-center'>
          <Flex>
            <Text>
              Atenção: esta URL (admin-parceiros.guigo.tv){' '}
              {Object.keys(timeLeft).find(it => timeLeft[it] > 0)
                ? 'NÃO estará mais disponível em:'
                : 'NÃO ESTÁ mais disponível'}
            </Text>
          </Flex>
          <Flex>
            <DisplayDays days={timeLeft.days} />
            <DisplayHours hours={timeLeft.hours} />
            <DisplayMinutes minutes={timeLeft.minutes} />
            <DisplaySeconds seconds={timeLeft.seconds} />
          </Flex>
        </Flex>
      </Container>
    </>
  )
}

export default CountDowntimer
